var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var commonConfig = {
    appBaseUrl: process.env.APP_BASE_URL,
    apiBaseUrl: process.env.API_BASE_URL,
    tokenKey: 'localStorage.token',
    recruiterTokenKey: 'localStorage.access',
    shouldIncludeAdminModule: true,
    organizationId: +process.env.ORGANIZATION_ID,
    applyVia: {
        allowGoogleAuth: true,
        allowLinkedInAuth: true,
    },
    applyFormFields: [
        {
            name: 'email',
            type: 'email',
            label: 'Email Address',
            placeholder: 'Enter email.',
            resumeParsedKey: 'email',
            required: true,
            isConfigurable: false,
            validation: {
                pattern: '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$',
            },
        },
        {
            name: 'name',
            type: 'text',
            label: 'Name',
            placeholder: 'Enter name.',
            resumeParsedKey: 'candidateName',
            required: true,
            isConfigurable: false,
            maxLength: 50,
        },
        {
            name: 'mobile_number',
            type: 'text',
            label: 'Mobile Number',
            isConfigurable: false,
            placeholder: 'Enter mobile number.',
            resumeParsedKey: 'contactNo',
            validation: {
                pattern: '^\\+?[1-9]\\d{1,14}$',
            },
        },
    ],
    jobListingPageUrl: '/',
};
export var jdConfig = __assign(__assign({}, commonConfig), { jobCard: {
        allowSharing: true,
        allowSendingEmail: true,
        allowSaving: true,
        showMatchingScore: true,
        allowComments: true,
        allowLikes: true,
        allowApplyJob: true,
        showJobPostedAt: true,
        showPostedBy: false,
        showJobExperience: true,
        showSalaryInfo: true,
        showNoticePeriodInfo: true,
        showContractTimePeriod: true,
        showLocation: true,
        showTimeAvailability: true,
        showGenderPreference: true,
    }, showJobHighlightsSection: true, jobDescriptions: {
        showJobDescriptionSection: true,
    }, showSkillsSection: true, showSimilarJobsSection: true, showApplicationStatusSection: true, showOtherJobsSection: false, templateId: 1, bannerUrl: '/banner.png' });
export var jobsConfig = __assign(__assign({}, commonConfig), { filters: {
        showFilters: true,
        isCollapsable: true,
        allowSearch: true,
    }, jobCard: {
        allowSharing: true,
        allowSaving: true,
        allowSorting: true,
        showMatchingScore: false,
        showSkills: true,
        allowComments: false,
        allowLikes: false,
        allowApplyJob: true,
        showJobPostedAt: true,
        showPostedBy: true,
        showJobMetaInfo: true,
        showJobExperience: true,
        showSalaryInfo: true,
        showNoticePeriodInfo: true,
        showContractTimePeriod: true,
        showLocation: true,
        showTimeAvailability: true,
        showGenderPreference: true,
    }, layout: {
        filterPosition: 'right',
        searchPosition: 'right',
        isSearchSticky: true,
        searchStickyTop: 0,
        isFilterSticky: true,
        filterStickyTop: 0,
    }, templateId: 1, bannerUrl: '/banner.png' });
export var myJobsConfig = __assign(__assign({}, commonConfig), { jobCard: {
        allowSharing: true,
        allowSaving: true,
        allowSorting: true,
        showMatchingScore: false,
        showSkills: true,
        allowComments: false,
        allowLikes: false,
        allowApplyJob: true,
        showJobPostedAt: true,
        showPostedBy: true,
        showJobMetaInfo: true,
        showJobExperience: true,
        showSalaryInfo: true,
        showNoticePeriodInfo: true,
        showContractTimePeriod: true,
        showLocation: true,
        showTimeAvailability: true,
        showGenderPreference: true,
        showAppliedAt: false,
    }, bannerUrl: '/banner.png', templateId: 1 });
